"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBoxChip = ListBoxChip;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const PresentationContext_1 = require("../../components/PresentationContext");
const Css_1 = require("../../Css");
function ListBoxChip({ label }) {
    var _a;
    const { fieldProps } = (0, PresentationContext_1.usePresentationContext)();
    return ((0, jsx_runtime_1.jsx)("span", { css: Css_1.Css[(_a = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.typeScale) !== null && _a !== void 0 ? _a : "sm"].tal.bgGray300.gray900.br16.pxPx(10).pyPx(2).lineClamp1.wbba.$, title: label, children: label }));
}
